import AxiosService from "@/infra/http/axios";

const authRepository = {
  /**
   * Função para logar usuário
   */
  async authUser(email: string, senha: string): Promise<any | null> {
    const Instance = await AxiosService.createAxiosInstance();

    const data = { email, senha };

    const userAuth = await Instance.post<any>(`login`, data, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return userAuth?.data;
  },

  /**
   * Função que busca os dados do usuário autenticado (inclui features)
   */
  async buscarDadosUsuario(accessToken: string): Promise<any | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const dadosUsuario = await Instance.get<any>(`users/dados`, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return dadosUsuario?.data;
  },

  /**
   * Gera código de uso único (60s) para abrir o backoffice já logado
   */
  async gerarCodigoAcessoBackoffice(accessToken: string): Promise<string | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const resposta = await Instance.post<{ data?: { codigo?: string } }>(
      `auth/codigo-acesso-backoffice`
    );

    return resposta?.data?.data?.codigo ?? null;
  },
};

/**
 * EXPORTS
 */
export { authRepository };
